import React, { useCallback } from 'react'
import { Avatar } from 'antd'
import { LogoutOutlined, QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons'
import { getDeleteSessionAction } from '../../store/session/action-creators'
import { DELETE_SESSION_DONE } from '../../store/session/actions'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch'
import { UserProfileMenuWrapper } from './styles'
import { useReleaseNotes } from './release-notes/provider'

interface UserProfileMenuProps {
  name: string
  officeName: string
  initials: string
  avatarUrl?: string | null
  onClose: () => void
}

export const UserProfileMenu = ({
  name,
  officeName,
  initials,
  avatarUrl,
  onClose,
}: UserProfileMenuProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const releaseNotes = useReleaseNotes()

  const handleLogoutClick = useCallback(async () => {
    onClose()
    const lastAction: any = await dispatch(getDeleteSessionAction())
    if (lastAction.type === DELETE_SESSION_DONE) {
      navigate('/')
    }
  }, [dispatch, navigate, onClose])

  const handleReleaseNotesClick = () => {
    onClose()
    releaseNotes?.openHistory()
  }

  return (
    <UserProfileMenuWrapper>
      <div className="profile-menu-identity">
        <Avatar className="profile-menu-avatar" size={48} src={avatarUrl || undefined}>
          {initials}
        </Avatar>
        <div className="profile-menu-details">
          <div className="profile-menu-name" title={name}>
            {name}
          </div>
          {officeName && (
            <div className="profile-menu-office" title={officeName}>
              {officeName}
            </div>
          )}
        </div>
      </div>
      <button
        className="profile-menu-action"
        type="button"
        onClick={() => {
          onClose()
          navigate('/profile')
        }}
      >
        <SettingOutlined aria-hidden="true" />
        <span>Настройки профиля</span>
      </button>
      <button className="profile-menu-action" type="button" onClick={handleReleaseNotesClick}>
        <QuestionCircleOutlined aria-hidden="true" />
        <span>Что нового в ERP</span>
      </button>
      <button className="profile-menu-action" type="button" onClick={handleLogoutClick}>
        <LogoutOutlined aria-hidden="true" />
        <span>Выйти</span>
      </button>
    </UserProfileMenuWrapper>
  )
}
